var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShortSpeedSkate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.2,77.8c-1.4,0-2.7,0.6-3.6,1.5L90.7,90.3l-9.4-9.5v-8c0-2.4-0.9-4.6-2.5-6.2c-0.1-0.1-27.4-27.4-27.4-27.4 c-2-2-5.3-2-7.3,0c-2,2-2,5.3,0,7.3L65,67.4c0,0-32.7,0-32.7,0L53,88.1h21l13,13c2,2,5.3,2,7.3,0l14.5-14.5 c0.9-0.9,1.5-2.2,1.5-3.6C110.4,80.1,108.1,77.8,105.2,77.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.3,
    cy: 70.2,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1,
    y: 134.3,
    width: 25.8,
    height: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3,98.6L27.6,69.9L0,97.5V112l27.5-27.5l17.8,17.7l-20.7,20.7c-2,2-2,5.3,0,7.3s5.3,2,7.3,0c0,0,24.3-24.3,24.3-24.3 C58.3,103.9,58.3,100.6,56.3,98.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M128.9,47.2c-1.4,0-2.7,0.6-3.6,1.5l-10.9,10.9l-9.5-9.5v-8c0-2.4-0.9-4.6-2.5-6.2C102.4,35.9,75,8.6,75,8.6 c-2-2-5.3-2-7.3,0c-2,2-2,5.3,0,7.3l20.9,20.9c0,0-32.7,0-32.7,0l20.7,20.6h21l13,13c2,2,5.3,2,7.3,0L132.6,56 c0.9-0.9,1.5-2.2,1.5-3.6C134.1,49.5,131.8,47.2,128.9,47.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116,
    cy: 39.5,
    rx: 9,
    ry: 9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortSpeedSkate);
export default __webpack_public_path__ + "static/media/shortSpeedSkate.1f9099353472b45805ec07ef1b0e73cd.svg";
export { ForwardRef as ReactComponent };